// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "http://api.haohd.link";
//let commonUrl = "https://trafigura-india.com";
let baseUrl = {
    commonUrl
}
 
export default baseUrl